import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class TipoPreciosService {

  constructor(private api: ApiService) {}

  // `_token` es legacy y se ignora (el token va en el header Bearer).

  listarTipoPrecios(_token?: any): Observable<{ rows: any[] }> {
    return this.api.post('/company/price-types/list', {});
  }

  crearTipoPrecio(descripcion: string, _token?: any): Observable<{ id: number }> {
    return this.api.post('/company/price-types/create', { descripcion });
  }

  editarTipoPrecio(idTipoPrecio: string, descripcion: string, _token?: any): Observable<{ id: number }> {
    return this.api.post('/company/price-types/update', { id: idTipoPrecio, descripcion });
  }

  eliminarTipoPrecio(idTipoPrecio: string, _token?: any): Observable<{ id: number }> {
    return this.api.post('/company/price-types/delete', { id: idTipoPrecio });
  }
}
